module.exports = __webpack_public_path__ + "img/company-icon.c64852f0.svg";